<template>
	<div class="search-fast" :class="size">
		<div class="label">{{ title }}</div>
		<div class="search-box">
			<input type="text" :placeholder="placeholder" v-model="text" />
			<div class="search-info">
				<ui-load-indicator v-if="load" 
					:h="25"
					:stroke="8"
					bgColor="#D5E0EC"
					color="#69D296" />
			</div>
			<div class="icon">
				<button v-if="text.length <= 3">
					<i class="fal fa-search"></i>
				</button>
				<button type="button" v-if="text.length > 3 && !load" @click="clear">
					<i class="fal fa-times"></i>
				</button>
			</div>
		</div>
		<section class="results" :class="text.length > 3 ? 'active' : ''">
			<h3>Resultados Encontrados:</h3>
			<div class="box scroll-color">
				<ul>
					<li v-for="item in results" :key="item.id">
						<div class="infos">
							<div class="name">{{ item.name }}</div>
							<div class="titles" v-if="item.infos.title">
								{{ item.infos.title }} - {{ item.infos.subtitle }}
							</div>
						</div>
						<div class="control">
							<ui-button type="submit"
								design="xs line-primary"
								@click="oldPanelLinkButton('empreendimentos/' + item.id + '/visualizar')">
                                Visualizar
                            </ui-button>
						</div>
					</li>
				</ul>
				<div class="no-results" v-if="!total">
					<span>Nenhum empreendimento encontrado.</span>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import uiLoadIndicator from '@/components/ui/load-indicator'
	import { uiButton } from '@/components/ui/buttons'
	import helpers from '@/mixins/helpers'
	export default {
		name: 'ui-fast-search',
		components: { uiLoadIndicator, uiButton },
		mixins: [helpers],
		props: {
			service: {
				type: String,
				required: false,
			},
			title: {
				type: String,
				required: false,
			},
			placeholder: {
				type: String,
				required: false,
			},
            /**
			 * Utilize para alterar o tamanho do input
			 */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
		},
		data() {
			return {
				text: '',
				results: [],
				total: 0,
				load: false,
			}
		},
		watch: {
			text() {
				if (this.text.length > 3) {
					this.search()
					this.total = 1
				} else {
					this.total = 0
				}
			},
		},
		computed: {
			loadService() {
				return () => import('@/services/axios/modules/' + this.service + '.js')
			},
		},
		methods: {
			search() {
				this.load = true
				this.api.search(this.text).then((response) => {
					this.results = response.data
					this.total = response.data.length
					this.load = false
				})
			},
			clear() {
				this.results = []
				this.total = 0
				this.text = ''
			},
		},
		created() {
			this.loadService().then((response) => {
				this.api = response.default.build()
			})
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
